var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27121",
    "data-name": "Group 27121",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13381",
    "data-name": "Rectangle 13381",
    width: 32,
    height: 33,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30612",
    "data-name": "Group 30612",
    transform: "translate(841.826 -465.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50103",
    "data-name": "Path 50103",
    d: "M-816.826,474.351v16.765a2.687,2.687,0,0,1-.829,1.936,2.828,2.828,0,0,1-1.97.79h-12.4a2.828,2.828,0,0,1-1.971-.79,2.683,2.683,0,0,1-.828-1.936V474.351a2.682,2.682,0,0,1,.828-1.935,2.833,2.833,0,0,1,1.971-.791h1.836v1.3h-1.836a1.531,1.531,0,0,0-1.068.425,1.385,1.385,0,0,0-.431,1v16.765a1.387,1.387,0,0,0,.431,1,1.531,1.531,0,0,0,1.068.425h12.4a1.531,1.531,0,0,0,1.068-.425,1.387,1.387,0,0,0,.431-1V474.351a1.385,1.385,0,0,0-.431-1,1.531,1.531,0,0,0-1.068-.425h-1.836v-1.3h1.836a2.832,2.832,0,0,1,1.971.791A2.687,2.687,0,0,1-816.826,474.351Z",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50104",
    "data-name": "Path 50104",
    d: "M-822.306,471.606v2.423a.276.276,0,0,1-.275.274h-6.491a.275.275,0,0,1-.274-.274v-2.423a.275.275,0,0,1,.274-.274h1.6c0-.022,0-.043,0-.065a1.646,1.646,0,0,1,1.647-1.646,1.646,1.646,0,0,1,1.646,1.646c0,.022,0,.043,0,.065h1.6A.276.276,0,0,1-822.306,471.606Z",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30611",
    "data-name": "Group 30611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30608",
    "data-name": "Group 30608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50105",
    "data-name": "Path 50105",
    d: "M-831.6,488.005a.125.125,0,0,1-.007-.177l.563-.611a.126.126,0,0,1,.177-.007l.978.9a.117.117,0,0,0,.172-.012l1.891-2.31a.127.127,0,0,1,.177-.018l.643.527a.125.125,0,0,1,.017.176l-2.618,3.2a.117.117,0,0,1-.172.012Z",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14224",
    "data-name": "Rectangle 14224",
    width: 6.562,
    height: 0.988,
    transform: "translate(-826.575 487.546)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30609",
    "data-name": "Group 30609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50106",
    "data-name": "Path 50106",
    d: "M-831.6,483.179a.125.125,0,0,1-.007-.177l.563-.611a.126.126,0,0,1,.177-.007l.978.9a.117.117,0,0,0,.172-.012l1.891-2.31a.128.128,0,0,1,.177-.018l.643.527a.125.125,0,0,1,.017.176l-2.618,3.2a.117.117,0,0,1-.172.012Z",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14225",
    "data-name": "Rectangle 14225",
    width: 6.562,
    height: 0.988,
    transform: "translate(-826.575 482.72)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30610",
    "data-name": "Group 30610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50107",
    "data-name": "Path 50107",
    d: "M-831.6,478.353a.125.125,0,0,1-.007-.177l.563-.611a.126.126,0,0,1,.177-.007l.978.9a.117.117,0,0,0,.172-.012l1.891-2.31a.127.127,0,0,1,.177-.018l.643.527a.125.125,0,0,1,.017.176l-2.618,3.2a.118.118,0,0,1-.172.012Z",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14226",
    "data-name": "Rectangle 14226",
    width: 6.562,
    height: 0.988,
    transform: "translate(-826.575 477.894)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.35
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryIcon);
export default __webpack_public_path__ + "static/media/SummaryIcon.baa6a87d.svg";
export { ForwardRef as ReactComponent };